import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Tools from './Tools';

export interface Props extends RouteComponentProps {
    userProfile: Profile;
}

export default withRouter(Tools);

